import DEFAULTS from '../defaults/authConfig';
import { RootState } from '../reducers';

export function getPollingIntervalSeconds({ authConfig }: RootState) {
  return authConfig.pollingIntervalSeconds;
}

export function getSentConfirmLink({ authConfig }: RootState) {
  return authConfig.sentConfirmLink || false;
}

export function getHaveValidLoginURLs({ authConfig }: RootState) {
  const { loginPollURL, loginActionURL, loginInitURL } = authConfig;

  return (
    loginPollURL !== DEFAULTS.loginPollURL &&
    loginActionURL !== DEFAULTS.loginActionURL &&
    loginInitURL !== DEFAULTS.loginInitURL
  );
}

export function getHaveValidRegisterURLs({ authConfig }: RootState) {
  const { registerPollURL, registerActionURL, registerInitURL } = authConfig;

  return (
    registerPollURL !== DEFAULTS.registerPollURL &&
    registerActionURL !== DEFAULTS.registerActionURL &&
    registerInitURL !== DEFAULTS.registerInitURL
  );
}
